import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { Switch } from "~/components/switch";

import type { FormState } from "./form-state";

export interface WidgetSparklineProps {
	name: string;
	sparkline: FormState;
}

export const WidgetSparkline: React.FC<WidgetSparklineProps> = ({ name, sparkline }) => {
	const monitor = useMonitor();

	return (
		<Switch checked={sparkline.getInput(monitor)} name={name} onCheckedChange={(show) => sparkline.setInput(show)} />
	);
};
